angular.module('dpw.services').factory('appProfileStatusHistoryService',
    ['$q', 'api', function ($q, api) {
        var types = {
            origin: ['app-profile', 'app-profile-revision'],
            revision: 'app-profile-revision'
        };

        return {
            types: types,
            fetch: function (options, paging) {
                return $q(function (resolve) {
                    api.call(api.appGallery.statusHistory(options, paging), function (data) {
                        resolve(data);
                    });
                });
            },
            fetchLatestOne: function (request) {
                var paging = {
                    page: 1,
                    pageEnd: 0,
                    pageStart: 0,
                    perPage: 1
                };
                return this.fetch(
                    {
                        appProfileId: request.id,
                        params: {
                            resourceTypes: types[request.type]
                        }
                    },
                    paging);
            }
        };
    }]);
